import { Language, ViolationType } from "types/interview"

export const LANGUAGE_INTERVIEW_STAGES = {
  feedback: "feedback",
  initialize: "initialize",
  interviewSetup: "interviewSetup",
  interviewDiscussion: "interviewDiscussion",
  interviewCoding: "interviewCoding",
  loading: "loading",
  continueConfirmation: "continueConfirmation",
  disqualification: "disqualification",
}

export const ASSISTANT_MAPPING: { [key in Language]: string } = {
  dsa: "dsa",
  java: "language#java",
  python: "language#python",
  javascript: "language#javascript",
  spring_boot: "language#spring_boot",
  javascript_sst: "language#javascript_sst",
  react: "language#react",
  mern: "language#mern",
  django: "language#django",
  python_basics: "language#python_basics",
  nlp: "language#nlp",
  computer_vision: "language#computer_vision",
  unsupervised_learning: "language#unsupervised_learning",
  supervised_learning: "language#supervised_learning",
  resume_discussion: "resume_discussion",
  devops_dsa: "language#devops_dsa",
  eda: "eda",
  angular: "language#angular",
  devops_linux_cs_fundamentals: "language#devops_linux_cs_fundamentals",
  demo_time_mba_personal_interview_mock: "demo_time_mba_personal_interview_mock",
  resume_consultation: "resume_consultation",
  ims_ai_personal_interview_ssb_internal_testing: "language#ims_ai_personal_interview_ssb_internal_testing",
  deepgram_streaming_testing: "language#deepgram_streaming_testing",
}

export const ASSISTANT_SLUG_MAPPING: any = {
  dsa: "dsa",
  javascript: "javascript",
  react: "react",
  mern: "mern",
  django: "django",
  nlp: "nlp",
  computer_vision: "computer_vision",
  unsupervised_learning: "unsupervised_learning",
  supervised_learning: "supervised_learning",
  resume_discussion: "resume_discussion",
  devops_dsa: "devops_dsa",
  eda: "eda",
  angular: "angular",
  ssb_screening_round: "ssb_screening_round",
  sst_screening_round: "sst_screening_round",
  devops_linux_cs_fundamentals: "devops_linux_cs_fundamentals",
  demo_time_mba_personal_interview_mock: "demo_time_mba_personal_interview_mock",
  resume_consultation: "resume_consultation",
  ims_ai_personal_interview_ssb_internal_testing: "ims_ai_personal_interview_ssb_internal_testing",
  deepgram_streaming_testing: "deepgram_streaming_testing",
}

export const ASSISTANT_MAPPING_NAMES: { [key in Language]: string } = {
  java: "Java",
  python: "Python",
  javascript: "JavaScript",
  spring_boot: "Spring Boot",
  javascript_sst: "Javascript(SST)",
  dsa: "DSA",
  react: "React",
  mern: "MERN",
  django: "Django",
  python_basics: "Python Basics",
  nlp: "NLP",
  computer_vision: "Computer Vision",
  unsupervised_learning: "Unsupervised Learning",
  resume_discussion: "Resume Discussion",
  supervised_learning: "Supervised Learning",
  devops_dsa: "DevOps DSA",
  eda: "EDA",
  angular: "Angular",
  devops_linux_cs_fundamentals: "DevOps Linux CS Fundamentals",
  demo_time_mba_personal_interview_mock: "TIME MBA Personal",
  resume_consultation: "Resume Consultation",
  ims_ai_personal_interview_ssb_internal_testing: "IMS AI Personal Interview (SSB Internal)",
  deepgram_streaming_testing: "Deepgram Streaming Testing",
}

export const PROCTOR_MODE_OPTIONS = [
  {
    value: "full_proctored",
    label: "Proctored",
  },
  {
    value: "non_proctored",
    label: "Non Proctored",
  },
]

export const PROBLEM_SECTION_ENABLED_MAPPING: { [key: string]: boolean } = {
  dsa: true,
  devops_dsa: true,
}

export const LS_INPUT_SOURCE_KEY = "companion/media-input-source"
export const LS_PROCTORING_AUTH_TOKEN = "proctoringToken"

export const DEFAULT_INPUT_SOURCE = { audioInput: null, videoInput: null }

export const FULL_SCREEN_TIMER_COUNTDOWN = 10 // 10 secs
export const SCREEN_SHARE_TIMER_COUNTDOWN = 20 // 20 secs
export const DUAL_CAMERA_TIMER_COUNTDOWN = 180 // 180 secs

export const INTERVIEW_DISQUALIFICATION_COLUMNS = [
  { title: "Violation", dataIndex: "violation", key: "violation" },
  { title: "Timestamp", dataIndex: "timeStamp", key: "timeStamp" },
]

export const INVALID_TRANSCRIPTS = ["Thank you.", "."]

export const INTERVIEW_TYPE = {
  dsa: "dsa",
  lld: "lld",
  sql: "sql",
  react: "react",
  django: "django",
  mern: "mern",
  hld: "hld",
  nlp: "nlp",
  resume_discussion: "resume_discussion",
  computer_vision: "computer_vision",
  unsupervised_learning: "unsupervised_learning",
  supervised_learning: "supervised_learning",
  devops_dsa: "devops_dsa",
  eda: "eda",
  angular: "angular",
  ssb_screening_round: "ssb_screening_round",
  sst_screening_round: "sst_screening_round",
  devops_linux_cs_fundamentals: "devops_linux_cs_fundamentals",
  demo_time_mba_personal_interview_mock: "demo_time_mba_personal_interview_mock",
  resume_consultation: "resume_consultation",
  ims_ai_personal_interview_ssb_internal_testing: "ims_ai_personal_interview_ssb_internal_testing",
  deepgram_streaming_testing: "deepgram_streaming_testing",
}

export const VIOLATION_TYPE_CONFIG: Record<ViolationType, string> = {
  fullScreenExit: "fullscreen_exit",
  copyPaste: "copy_paste",
  tabSwitch: "tab_switch",
  pageReload: "page_reload",
  screenShareExit: "screen_share_exit",
  mobileCameraDisconnected: "mobile_camera_disconnected",
}

export const OWNER_TYPE_MAPPING = {
  dsa: "TestSession",
  language: "Conversation",
  lld: "TestSession",
  hld: "TestSession",
  sql: "TestGroupSession",
}

export const REPORT_ISSUE_TYPES = [
  { value: "Incorrect Responses", label: "Incorrect or irrelevant responses" },
  { value: "Slow Response", label: "Slow response time" },
  { value: "Connecting Issue", label: "Connecting Issue" },
  { value: "Interview Stuck", label: "Interview Stuck" },
  { value: "Audio Issue", label: "Audio Issue" },
  { value: "Microphone Issue", label: "Microphone Issue" },
  { value: "Other", label: "Other" },
]

export const SCREEN_SHARE_GUIDELINES = [
  'Click on "Share screen" button',
  'In the popup, choose "Entire screen"',
  "Pick the screen to share (if you have multiple monitors)",
  'Click "Share"',
]

export const RESUME_REQUIRED_INTERVIEWS: Language[] = [
  "resume_discussion",
  "demo_time_mba_personal_interview_mock",
  "resume_consultation",
]

export const FEEDBACK_HIRE_STATUS = {
  disqualified: "disqualified",
}

// Design mocks separate route configurable ----------

export const DESIGN_MOCKS_SLUG = {
  "sst-hld-design-stock-exchange": "sst_hld_design_stock_exchange",
}

export const DESIGN_MOCKS_TITLE = {
  "sst-hld-design-stock-exchange": "SST HLD Mock Interview - Design Stock Exchange",
}

export const DEFAULT_TEXT_TO_VOICE_CONFIG = {
  text_to_voice: {
    interviewer: {
      name: "Anshuman Singh",
      image: "https://companion-user-resumes.s3.ap-south-1.amazonaws.com/assets/anshuman.webp",
    },
    service: "elevenlabs",
    voice_id: "jJg2WC3y42dxA5pvdY26",
    fallback: [
      {
        service: "cartesia",
        voice_id: "bf0a246a-8642-498a-9950-80c35e9276b5",
      },
    ],
  },
}

export const JOB_FUNCTIONS = [
  "Product Analyst",
  "Fullstack Developer",
  "Frontend Developer",
  "Backend Developer",
  "DevOps Engineer",
  "Testing Engineer",
  "Data Analyst",
  "AI/ML Engineer",
]
